<template>
    <v-card elevation="0" outlined rounded="lg" :to="`/recruitments/${recruitment?._id}`" class="h-100">
        <v-layout column justify-space-between fill-height>
            <div class="w-100">
                <v-layout justify-center class="pa-20 pa-md-30 border-bottom">
                    <v-img :aspect-ratio="208 / 60" max-width="208" contain class="w-100" :src="recruitment?.company?.logo?.url">
                        <v-fade-transition>
                            <v-overlay v-show="!recruitment?.company?.logo?.url" absolute light color="white">
                                <image-overlay>{{ recruitment.company.name }}</image-overlay>
                                <!-- <v-layout row align-center class="black--text">
                                    <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                    <span> {{ recruitment.company.name }} </span>
                                </v-layout> -->
                            </v-overlay>
                        </v-fade-transition>
                    </v-img>
                </v-layout>
                <div class="pt-20 pt-md-24 px-20 px-md-24">
                    <h5 class="main-recruitment-card__tit page-text--lg font-weight-medium word-keep-all mb-12 mb-lg-20">{{ recruitment.subject }}</h5>
                    <p class="page-text primary--text mb-4">{{ recruitment.company.name }}</p>
                    <p class="page-text mb-8 mb-lg-16">{{ employmentPlace }}</p>
                    <v-chip-group>
                        <template v-for="item in recruitment?.employment?.typesTexts || []">
                            <v-chip outlined color="grey-d" :key="item">
                                <span class="grey-6--text">{{ item }}</span>
                            </v-chip>
                        </template>
                    </v-chip-group>
                </div>
            </div>
            <div class="w-100 pb-20 pb-md-24 px-20 px-md-24 mt-8 mt-lg-16">             
                <v-row align="center" class="row--small">
                    <v-col>
                        <recruitment-view-application class="page-text line-height-1 grey-9--text" onlyDaysLeft :application="recruitment.application" />
                    </v-col>
                    <v-col cols="auto">
                        <like-btn :params="params__likeBtn">
                            <template #activator="{ active, toggle }">
                                <v-btn icon text small :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                    <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                </v-btn>
                            </template>
                        </like-btn>
                    </v-col>
                </v-row>
            </div>
        </v-layout>
    </v-card>
</template>

<script>
import { initRecruitment, USER_LIKE_TYPES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";
import RecruitmentViewApplication from "@/components/dumb/recruitment-view-application.vue";
import ImageOverlay from "@/components/dumb/image-overlay.vue";

export default {
    components: {
        LikeBtn,
        RecruitmentViewApplication,
        ImageOverlay,
    },
    props: {
        recruitment: { type: Object, default: initRecruitment },
    },
    computed: {
        params__likeBtn() {
            return {
                _recruitment: this.recruitment._id,
                type: USER_LIKE_TYPES.RECRUITMENT.value,
            };
        },
        employmentPlace() {
            const { isAbroad, address1 = "" } = this.recruitment?.employment?.place || {};
            if (isAbroad) return "해외";
            else return address1?.split?.(" ")?.slice?.(0, 2)?.join?.(" ");
        },
    },
};
</script>

<style lang="scss" scoped>
.main-recruitment-card__tit {
    width: 100%;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
}
::v-deep .v-chip.v-size--default {
    font-size: 1.4rem;
    border-radius: 6px;
}
</style>
